import api from './interceptor';

const BASE_URL_V1 = 'api/v1/clinics';
const BASE_URL_V2 = 'api/v2/clinics';

export default {
  // API Version 1
  getClinics: params => api.get(`${BASE_URL_V1}`, { params }),
  getClinicById: clinicId => api.get(`${BASE_URL_V1}/${clinicId}`),
  deleteClinic: clinicId => api.delete(`${BASE_URL_V1}/${clinicId}`),
  activateClinic: clinicId => api.put(`${BASE_URL_V1}/${clinicId}/activate`),
  deactivateClinic: clinicId => api.put(`${BASE_URL_V1}/${clinicId}/deactivate`),
  getNewClinicsWithoutPermissions: params => api.get(`${BASE_URL_V1}/no-permissions`, { params }),
  updateLogo: (clinicId, params) => api.patch(`${BASE_URL_V1}/${clinicId}/logo`, params),

  // API Version 2
  getDepartments: (clinicId, params) => api.get(`${BASE_URL_V2}/${clinicId}/departments`, { params }),
  getCountries: () => api.get(`${BASE_URL_V2}/states`),
  getCurrencies: () => api.get(`${BASE_URL_V2}/currencies`),
  getDepartmentsNoAuth: (clinicId) => api.get(`${BASE_URL_V2}/no-auth/${clinicId}/departments`),
  getAllEmrs: () => api.get(`${BASE_URL_V2}/all-emrs`),
  getFeatures: () => api.get(`${BASE_URL_V2}/features`),
  addClinic: params => api.post(`${BASE_URL_V2}`, params),
  updateClinic: (params, id) => api.put(`${BASE_URL_V2}/${id}`, params),
  setDepartmentStatus: (clinicId, departmentId, params) => api.patch(`${BASE_URL_V2}/${clinicId}/${departmentId}`, params),
  deleteDepartment: (clinicId, departmentId) => api.delete(`${BASE_URL_V2}/${clinicId}/departments/${departmentId}`),
  getDiscounts: (clinicId, params) => api.get(`${BASE_URL_V2}/${clinicId}/discounts/`, { params }),
  deleteDiscount: (clinicId, discountId) => api.delete(`${BASE_URL_V2}/${clinicId}/discounts/${discountId}`),
  updateDiscount: (clinicId, discountId, params) => api.put(`${BASE_URL_V2}/${clinicId}/discounts/${discountId}`, params),
  createDiscount: (clinicId, params) => api.post(`${BASE_URL_V2}/${clinicId}/discounts`, params),
  getDiscountHistory: (clinicId, discountId, params) => api.get(`${BASE_URL_V2}/${clinicId}/discounts/${discountId}`, params),
  getClinicAddedQuestions: (clinicId) => api.get(`${BASE_URL_V2}/${clinicId}/questions`),
  addQuestion: (clinicId, params) => api.post(`${BASE_URL_V2}/${clinicId}/questions/add-batch`, params),
  removeQuestion: (clinicId, data) => api({
    method: 'DELETE',
    url: `${BASE_URL_V2}/${clinicId}/questions/remove-batch`,
    data,
  }),
  getClinicsByIds: params => api.get(`${BASE_URL_V2}/by-ids`, { params }),

  getCustomQuestions: (clinicId) => api.get(`${BASE_URL_V2}/${clinicId}/custom-questions`),
  createCustomQuestions: (clinicId, data) => api.post(`${BASE_URL_V2}/${clinicId}/custom-questions`, data),
  updateCustomQuestion: (clinicId, questionId, data) => api.put(`${BASE_URL_V2}/${clinicId}/custom-questions/${questionId}`, data),
  deleteCustomQuestion: (clinicId, questionId) => api.delete(`${BASE_URL_V2}/${clinicId}/custom-questions/${questionId}`),
};
